import { formatDate } from 'utilities/date.js';

export const createTideHeaderDate = (date: string) => ({
  day: formatDate(date, 'EEE').toUpperCase(),
  date: formatDate(date, 'dd MMM').toUpperCase(),
});

export const EmptyTideCell = () => (
  <td>
    <div>-</div>
  </td>
);
